// extracted by mini-css-extract-plugin
export default {"wrap":"Rating_wrap__iJVQb","star":"Rating_star__PIgwb","filled":"Rating_filled__TMnor","icon":"Rating_icon__YnNPU"};